import { useLocalStorage } from "@uidotdev/usehooks";

import { DropdownSelectItem } from "@/components/ui/Dropdown/DropdownSelect";

import timezonesJSON from "@/assets/timezones.json";

const TIMEZONE_ITEMS = timezonesJSON as DropdownSelectItem[];

export const UTC_TIMEZONE: DropdownSelectItem = TIMEZONE_ITEMS.find(
  (item) => item.key === "UTC",
) ?? {
  label: "UTC",
  value: "UTC",
  key: "UTC",
};

function findTimezoneItem(tzKey: string): DropdownSelectItem | undefined {
  return TIMEZONE_ITEMS.find((item) => item.key === tzKey);
}

/**
 * Effective timezone: saved preference, else browser IANA if listed, else UTC.
 */
export function resolveTimezone(
  stored: Maybe<DropdownSelectItem>,
  browserTzKey: string,
): DropdownSelectItem {
  if (stored?.key) {
    return stored;
  }

  const browserMatch = findTimezoneItem(browserTzKey);
  if (browserMatch) {
    return browserMatch;
  }

  return UTC_TIMEZONE;
}

export function useTimezone() {
  const browserTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const browserMatch = findTimezoneItem(browserTz);

  const [tz, setTz] = useLocalStorage<Maybe<DropdownSelectItem>>(
    "tz",
    browserMatch,
  );

  return {
    tz: resolveTimezone(tz, browserTz),
    setTz,
  };
}
